<script lang="ts">
    import {getLocalization} from 'core/svelte-context/context';
    import {createEventDispatcher} from 'svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let showResetFormButton: boolean;

    const localize = getLocalization();
    const dispatch = createEventDispatcher<{ 'reset': void, 'toggle-expert-search': boolean }>();

    let expertSearch = false;
    $: dispatch('toggle-expert-search', expertSearch);
</script>

<div class="search-form-heading-part">
    <h1>
        {localize(/* @kp-localization hledani.RozsireneVyhledavani */ 'hledani.RozsireneVyhledavani')}
    </h1>

    <button class="reset-btn unset-style"
            data-qa="clear-search-form-button"
            class:shown={showResetFormButton}
            on:click={() => dispatch('reset')}>

        <IconedContent icon="undo">
            {localize(/* @kp-localization commons.ResetForm */ 'commons.ResetForm')}
        </IconedContent>
    </button>

    <label class="expert-search-container">
        <input type="checkbox" bind:checked="{expertSearch}"/>
        {localize(/* @kp-localization hledani.ExpertniRezim */ 'hledani.ExpertniRezim')}
    </label>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .search-form-heading-part {
        display: flex;
        align-items: center;
        gap: @spacing-ml;

        h1 {
            margin: 0;
            flex: 1;
        }

        .reset-btn {
            cursor: pointer;
            color: var(--danger-red);
            visibility: hidden;
            opacity: 0;

            &.shown {
                visibility: visible;
                opacity: 1;
            }

            &:not(.shown) {
                display: none;
            }
        }

        .expert-search-container {
            margin: 0;
            padding: 0;
            cursor: pointer;
        }
    }
</style>